'use strict';

const COMPUTED_STEP_TARGET_EVENT = {
  EVENT_ID_MAIL_REPLIED: 1,
  EVENT_ID_NO_EMAIL: 2,
  EVENT_ID_OPTOUT: 3,
  EVENT_ID_INACTIVE: 4,
  EVENT_ID_SKIPPED: 5,
};

export {
  COMPUTED_STEP_TARGET_EVENT,
};
